import type { AnalyticsCardHeader } from '../../../analyticsModule/components/AnalyticsCard/AnalyticsCard.types'
import type { AnalyticsReportDefinition } from '../../../types'

export const createAnalyticsCardHeader = (
  reportDefinition: AnalyticsReportDefinition | undefined,
  activeColumn: AnalyticsReportDefinition['columns'][0] | undefined,
): AnalyticsCardHeader => ({
  label: reportDefinition?.name || '',
  tooltip: activeColumn?.tooltip
    ? {
        title: activeColumn.tooltip.title,
        description: activeColumn.tooltip.description,
        // TODO: Add formula
      }
    : undefined,
})
